import { generateBaseQueryKeysList } from '@/queries/utils';

export const BANNED_DRIVERS_KEYS = {
  main: 'banned-drivers',
};

export const bannedDriversQueryKeys = generateBaseQueryKeysList(BANNED_DRIVERS_KEYS.main);
